import api from '@/api';
import { GET_CHARGE_DATA, SET_PAST_ORDERS_SHOW } from './types';

export default {
  [GET_CHARGE_DATA]: async ({ commit }, { token, orderId }) => {
    const resp = await api.kiosk.chargeOrder({ token, orderId });

    commit(GET_CHARGE_DATA, resp.data.charge);

    return resp;
  },
  [SET_PAST_ORDERS_SHOW]: async ({ commit }, { show }) => {
    commit(SET_PAST_ORDERS_SHOW, show);
  },
};



// WEBPACK FOOTER //
// ./src/apps/kiosk/store/actions.js